<template>
	<div>
		<component :is="dashboard" :user="user"/>
	</div>
</template>
<script>
import DashboardBasic from './dashboard/basic';
import DashboardOperadoraLoteria from './dashboard/operadora-loteria';
import DashboardSistema from './dashboard/sistema';
import DashboardInstitution from './dashboard/institution';

export default {
	components: {
		DashboardBasic,
		DashboardOperadoraLoteria,
        DashboardSistema,
        DashboardInstitution
	},
	computed: {
		user: function () {
			return this.$store.getters['persist/auth/user'];
		},
		dashboard: function () {
			switch (this.user.domain?.slug) {
				case 'operadora-loteria': return 'DashboardOperadoraLoteria';
                case 'sistema':           return 'DashboardSistema';
                case 'institution':       return 'DashboardInstitution';
				default:                  return 'DashboardBasic';
			}
		}
	},
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', '');
    }
}
</script>